import styled from "styled-components";

export const ImgFondo = styled.img`
  position: absolute;
  top: 0;
  z-index: -1;
  width: 100%;
  @media (max-width: 768px) {
  }
`;
